import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/$locale/email-preferences')({
  ssr: false,
  validateSearch: z.object({
    t: z.string().optional(),
  }),
})
